var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-va',{attrs:{"base_info":_vm.base_info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }